module.exports = __webpack_public_path__ + "images/faviconDot-8230142da9eae3b69b3531f2a998c7f9.ico";